import React from "react"

import { Grid, Typography } from "@material-ui/core"
import Breadcrumb from "@/components/BreadcrumbNew"
import ReportCard from "@/pages/Admin/Reports/components/ReportCard"

import { LocalOfferOutlined as TagIcon, TrackChanges, Phone as PhoneIcon } from "@material-ui/icons"
import { reportsTypeToTitle, ReportsType } from "@/protocols/reports"

import useStyles from "@/pages/Admin/Reports/styles"
import useSubscriptionLimits from "@/hooks/useSubscriptionLimits"

type ReportCardData = {
	icon: React.ReactNode
	title: string
	description: string
	type: ReportsType
}

const tagReports : ReportCardData[] = [
	{
		icon: <TagIcon />,
		title: reportsTypeToTitle["tags-report"],
		description: "Acompanhe a quantidade de clientes associados às suas tags.",
		type: "tags-report"
	}
]

const utmReports : ReportCardData[] = [
	{
		icon: <TrackChanges />,
		title: reportsTypeToTitle["utms-report"],
		description: "Acompanhe a quantidade de cliques e mensagens enviadas por UTM.",
		type: "utms-report"
	}
]

const voiceCallReports : ReportCardData[] = [
	{
		icon: <PhoneIcon />,
		title: reportsTypeToTitle["voice-call-report"],
		description: "Acompanhe o histórico de ligações realizadas e os minutos do plano consumidos.",
		type: "voice-call-report"
	}
]

const Reports: React.FC = () => {
	const classes = useStyles()
	const canUseTrackableLinks = useSubscriptionLimits("permission", "trackable_links")
	const canUseTrackableLinksTemporary = useSubscriptionLimits("permission", "trackable_links_temporary")

	const shouldUtmsReportBeShown = React.useMemo(() => {
		const isNotLoading = !canUseTrackableLinks.isLoading && !canUseTrackableLinksTemporary.isLoading
		const hasPermission = !canUseTrackableLinks.mustBlock || !canUseTrackableLinksTemporary.mustBlock
		return isNotLoading && hasPermission
	}, [
		canUseTrackableLinks.mustBlock,
		canUseTrackableLinks.isLoading,
		canUseTrackableLinksTemporary.mustBlock,
		canUseTrackableLinksTemporary.isLoading
	])

	return (
		<>
			<Grid
				container
				direction="column"
				spacing={5}>

				<Grid item>
					<Grid
						container
						direction="column"
						spacing={3}
					>
						<Grid item>
							<Breadcrumb
								data={[
									{ name: "Relatórios", pathname: "/admin/reports" }
								]}
							/>
						</Grid>

						<Grid item>
							<Grid container direction="column" spacing={4}>

								<Grid
									item
								>
									<Typography
										variant="h5"
										className={classes.titleText}
									>
										Relatórios
									</Typography>
								</Grid>

							</Grid>
						</Grid>

					</Grid>
				</Grid>

				<Grid item>
					<Grid container direction="column" spacing={5}>
						<Grid item>
							<Grid
								container
								direction="column"
								spacing={3}
							>
								<Grid item>
									<Typography
										variant="h4"
										className={classes.subtitleText}>
											TAGS
									</Typography>
								</Grid>

								{
									tagReports.map((report, index) => (
										<Grid item key={index}>
											<ReportCard
												icon={report.icon}
												title={report.title}
												description={report.description}
												type={report.type}
											/>
										</Grid>
									))
								}

							</Grid>
						</Grid>
						{shouldUtmsReportBeShown && (
							<Grid item>
								<Grid
									container
									direction="column"
									spacing={3}
								>
									<Grid item>
										<Typography
											variant="h4"
											className={classes.subtitleText}>
											UTMs
										</Typography>
									</Grid>

									{
										utmReports.map((report, index) => (
											<Grid item key={index}>
												<ReportCard
													icon={report.icon}
													title={report.title}
													description={report.description}
													type={report.type}
												/>
											</Grid>
										))
									}
								</Grid>
							</Grid>
						)}

						<Grid item>
							<Grid
								container
								direction="column"
								spacing={3}
							>
								<Grid item>
									<Typography
										variant="h4"
										className={classes.subtitleText}>
										LIGAÇÕES
									</Typography>
								</Grid>

								{
									voiceCallReports.map((report, index) => (
										<Grid item key={index}>
											<ReportCard
												icon={report.icon}
												title={report.title}
												description={report.description}
												type={report.type}
											/>
										</Grid>
									))
								}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	)
}

export default Reports
